import React from 'react';
import { ProjectPersonnelKpiRow } from './ProjectPersonnelKpiRow';
import { ProjectPersonnelHeader } from './ProjectPersonnelHeader';
import { ProjectPersonnelList } from './ProjectPersonnelList';
import { ProjectPersonnelSidebar } from './ProjectPersonnelSidebar';
import { useProjectPersonnel } from '../hooks/useProjectPersonnel';

export function ProjectPersonnelMain() {
  const { data, isLoading } = useProjectPersonnel();

  if (isLoading) {
    return <div className="p-10 text-center text-slate-400">Đang tải dữ liệu nhân sự...</div>;
  }

  return (
    <div className="space-y-6">
      {/* Hàng KPI hàng đầu */}
      <ProjectPersonnelKpiRow kpis={data.kpis} />

      {/* Bộ lọc & Danh sách */}
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 items-start">
        <div className="xl:col-span-9 space-y-6">
          <ProjectPersonnelHeader />
          <ProjectPersonnelList personnel={data.personnel} />
        </div>

        {/* Sidebar Thống kê */}
        <div className="xl:col-span-3">
          <ProjectPersonnelSidebar data={data} />
        </div>
      </div>
    </div>
  );
}
